// extracted by mini-css-extract-plugin
module.exports = {"BreakpointXSmall":"375px","BreakpointSmall":"768px","BreakpointMedium":"1024px","BreakpointLarge":"1280px","BreakpointXLarge":"1600px"};